import React, { ComponentProps, useState } from "react";

import { Root as PrimitiveRoot } from "@radix-ui/react-popover";

import { Provider } from "./dialog.context";

export interface DialogRootProps extends ComponentProps<typeof PrimitiveRoot> {
  onOpenChange?: (isOpen: boolean) => void;
}

const DialogRootComponent = ({ onOpenChange, ...props }: DialogRootProps) => {
  const [isOpen, setIsOpen] = useState(props.defaultOpen || false);

  const handleOpenChange = (newState: boolean) => {
    setIsOpen(newState);
    onOpenChange?.(newState);
  };

  return (
    <Provider value={{ isOpen, setIsOpen: handleOpenChange }}>
      <PrimitiveRoot open={isOpen} {...props} />
    </Provider>
  );
};

export const DialogRoot = React.memo(DialogRootComponent);
export default React.memo(DialogRootComponent);
